import styled from "styled-components";

export const Wrapper = styled.section`
  align-items: center;
`;

export const Item = styled.section`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  padding: 10px;
  height: 100%;
  background-color: white;
`;

export const SelectionWrapper = styled.div`
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Selection = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  padding: 5px;
  margin: 0 5px 0 5px;
  border-radius: 20px;
  cursor: pointer;
  background-color: ${props => (props.isSelected ? "#91d5ff55" : "none")};
`;
